import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import baseUrl from "../../baseUrl";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email && password) {
      axios
        .post(`${baseUrl}/admin/login`, {
          email,
          password,
        })
        .then((res) => {
          if (res.data.success == true) {
            localStorage.setItem("admin-token", JSON.stringify(res.data.token));
            localStorage.setItem(
              "admin-profile",
              JSON.stringify(res.data.user)
            );
            navigate("/");
            toast.success(res.data.message);
          }
          if (res.data.success == false) {
            navigate("/admin/login");
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <>
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.3.0/font/bootstrap-icons.css"
      />

      <div className="container w-screen h-screen flex justify-center items-center bg-gray-100">
        <form
          className="p-10 bg-white rounded flex justify-center items-center flex-col shadow-md"
          onSubmit={handleSubmit}
        >
          <a href="/">
            <img
              src="/logo.png"
              alt="aa"
              className="w-20 h-20 text-gray-600 mb-2"
            />
          </a>

          <p className="mb-5 text-xl text-gray-600">
            Login Into Your Account as Admin
          </p>

          <input
            type="email"
            name="email"
            className="mb-1 p-2 w-80 focus:border-purple-700 rounded border-2 outline-none"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="password"
            name="password"
            value={password}
            className="mb-1 p-2 w-80 focus:border-purple-700 rounded border-2 outline-none"
            placeholder="Password"
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button
            className="bg-purple-600 hover:bg-purple-900 text-white font-bold p-2 rounded w-80 mt-8"
            id="login"
            type="submit"
          >
            Login
          </button>
        </form>
      </div>
    </>
  );
};

export default Login;
